import { getSingleImgInfo, getPurchasePrice } from '@/api/design'
// ,,
import { mergeImg, getWhCm } from '@/utils/util'
// eslint-disable-next-line no-unused-vars
import { resetScenes } from '@/utils/threeScene.js'
import Vue from 'vue'
let timer = null
const design = {
  state: {
    copyProductId: '',
    slideIndex: 0,
    printImgInfo: {},
    showImgList: [],
    showImgListBig: [],
    all_show_images_design: [],
    all_bottom_images_template: [],
    print_areas: [],
    fabricList: [],
    activeDesign: 1,
    activeTab: 1,
    basic_product_id: 0,
    subColor: '', // 组合产品颜色
    subSize: '', // 组合产品尺码
    showColor: '',
    initialColor: '',
    initialSize: '',
    layerActive: '',
    // 是否上色全部面
    syncOtherSide: false,
    // 弹窗配置
    priceData: {},
    showImgDetail: '',
    showImgDetailData: {},
    font: 'Hanalei Fill',
    fontSize: 50,
    singlePxToAtualWidth: 0,
    tipLevels: {
      1: 0
    },
    onePxToRealWidth: 0,
    // 当前平铺图片信息
    groupInfo: {
      1: {
        code: '',
        type: 0,
        paddingX: 0,
        paddingY: 0
      }
    },
    // 文字输入框
    textValue: '请输入英文字母',
    // 全屏缩放大小
    zoom: 1,
    hotKeys: [
      {
        name: '上移',
        enName: 'Up',
        index: -1
      },
      {
        name: '下移',
        enName: 'Down',
        index: -2
      },
      {
        name: '左移',
        enName: 'Left',
        index: -3
      },
      {
        name: '右移',
        enName: 'Right',
        index: -4
      },
      {
        name: '填充',
        enName: 'Ctrl + B',
        index: 1
      },
      {
        name: '适应',
        enName: 'Alt + B',
        index: 2
      },
      {
        name: '水平镜像',
        enName: 'Alt + V',
        index: 5
      },
      {
        name: '垂直镜像',
        enName: 'Alt + N',
        index: 6
      },
      {
        name: '顺时针90°旋转',
        enName: 'Ctrl + Q',
        index: 7
      },
      {
        name: '删除',
        enName: 'Delete',
        index: 20
      },
      {
        name: '保存产品',
        enName: 'Ctrl + S',
        index: 10
      },
      {
        name: '选择产品',
        enName: 'Ctrl + F1',
        index: 11
      },
      {
        name: '主题设计',
        enName: 'Ctrl + F2',
        index: 12
      },
      {
        name: '重新设计',
        enName: 'Alt + R',
        index: 13
      },
      {
        name: '图案平铺-基础',
        enName: 'Alt + S',
        index: 14
      },
      {
        name: '图案平铺-镜像',
        enName: 'Alt + C',
        index: 15
      },
      {
        name: '旋转5°',
        enName: 'Alt + Q',
        index: 16
      },
      {
        name: '旋转45°',
        enName: 'Alt + W',
        index: 17
      },
      {
        name: '撤销',
        enName: 'Ctrl + Z',
        index: -5
      },
      {
        name: '恢复',
        enName: 'Ctrl + Y',
        index: -6
      }
    ],
    productDetail: {}, // 产品详情
    canvasType: '', // 判断当前画布选中对象img 为选中的是图片text为选中的文字
    designStyle: '',
    gifVisible: true,
    originalImgList: [],
    defaultColorId: 0, // 设置默认颜色
    defaultSizeId: 0, // 设置默认尺码,
    getWhSize: ''
  },
  getters: {
    getCopyProductId: state => {
      return state.copyProductId
    },
    getHotKeys: state => {
      return state.hotKeys
    },
    canvasType: state => {
      return state.canvasType
    },
    productDetail: state => {
      return state.productDetail
    },
    tipLevel: state => {
      return state['tipLevels'][state['activeDesign']]
    },
    showImgListTransform: state => {
      // console.log(state)
      // return state.showImgList
      const { showImgList } = state
      if (showImgList.length) {
        const newArr = []
        for (let i = 0; i < showImgList.length; i = i + 4) {
          newArr.push(showImgList.slice(i, i + 4))
        }
        return newArr
      } else {
        return []
      }
    },
    designColors: state => (state.printImgInfo.colors ? state.printImgInfo.colors : []),
    designSizes: state => (state.printImgInfo.sizes ? state.printImgInfo.sizes : []),

    activeFabric: state => {
      const activeFabric = state.fabricList.find(item => {
        return item.view_id === state.activeDesign
      })
      return activeFabric ? activeFabric.canObj : undefined
    },
    show_images_design: state => {
      const color_id = state.subColor || state.showColor || state.initialColor
      return state.all_show_images_design
        .map(item => item.filter(ite => ite.color_id === color_id))
        .filter(item => item.length !== 0)
    },
    bottom_images_template: state => {
      const color_id = state.subColor || state.initialColor
      return state.all_bottom_images_template.filter(item => item.color_id === color_id)
    },
    activePrintAreas: state => {
      const activePrintAreas = state.print_areas.filter(item => {
        return item.view_id === state.activeDesign
      })
      return activePrintAreas[0]
    },
    activeGroupInfo: state => {
      return state.groupInfo[state.activeDesign]
    }
  },
  mutations: {
    SET_SUB_COLOR: (state, data) => {
      state.subColor = data
    },
    SET_SUB_SIZE: (state, data) => {
      state.subSize = data
    },
    SET_DEFAULT_COLOR_ID: (state, data) => {
      state.defaultColorId = data
    },
    SET_DEFAULT_SIZE_ID: (state, data) => {
      state.defaultSizeId = data
    },
    SET_COPY_PRODUCT_ID: (state, data) => {
      state.copyProductId = data
    },
    SET_HOTKEYS: (state, data) => {
      state.hotKeys = data
    },
    SET_CANVAS_TYPE: (state, data) => {
      state.canvasType = data
    },
    SET_GIF_VISIBLE: (state, data) => {
      state.gifVisible = data
    },
    SET_PRODUCT_DETAIL: (state, data) => {
      state.productDetail = data
    },
    SET_SLIDER_INDEX: (state, data) => {
      state.slideIndex = data
    },
    SET_DESIGN_STYLE: (state, data) => {
      state.designStyle = data
    },
    SET_ZOOM: (state, data) => {
      state.zoom = 1 / data
    },
    SET_TEXT_VALUE: (state, data) => {
      state.textValue = data
    },
    SET_INITIAL_GROUP_INFO: (state, data) => {
      state.groupInfo = data
    },
    SET_GROUP_CODE: (state, data) => {
      state.groupInfo[data.activeDesign].code = data.data
    },
    SET_GROUP_TYPE: (state, data) => {
      state.groupInfo[data.activeDesign].type = data.data
    },
    SET_GROUP_PADDING_X: (state, data) => {
      state.groupInfo[data.activeDesign].paddingX = data.data
    },
    SET_GROUP_PADDING_Y: (state, data) => {
      state.groupInfo[data.activeDesign].paddingY = data.data
    },
    SET_ONE_PX_TO_REAL_WIDTH: (state, data) => {
      state.onePxToRealWidth = data
    },
    SET_ACTIVE_GROUP_CODE: (state, data) => {
      state.activeGroupCode = data
    },
    SET_TIP_LEVEL: (state, data) => {
      const { activeDesign } = state
      // state.tipLevel = data
      state.tipLevels[activeDesign] = data
    },
    SET_INIT_TIP_LEVEL: (state, data) => {
      state.tipLevels = data
    },
    SET_FONT: (state, data) => {
      state.font = data
    },
    SET_FONT_SIZE: (state, data) => {
      state.fontSize = data
    },
    SET_SHOW_IMG_DETAIL: (state, data) => {
      state.showImgDetail = data
    },
    SET_SHOW_IMG_DETAIL_DATA: (state, data) => {
      state.showImgDetailData = data
    },
    SET_CONFIG_DATA: (state, data) => {
      state.configData = data
    },
    RESET_FABRIC_LIST: state => {
      for (let i = 0; i < state.fabricList.length; i++) {
        state.tipLevels[i + 1] = 0
        state.fabricList[i].canObj.clear()
        state.fabricList[i].canObj.renderAll()
      }
      state.tipLevel = 0
    },
    SET_SYNC_OTHER_SIDE: (state, data) => {
      state.syncOtherSide = data
    },
    ClEAR_FABRIC_LIST: state => {
      state.fabricList = []
    },
    SET_SHOW_COLOR: (state, data) => {
      state.showColor = data
    },
    SET_INITIAL_COLOR: (state, data) => {
      state.initialColor = data
      resetScenes()
    },
    SET_INITIAL_SIZE: (state, data) => {
      state.initialSize = data
    },
    SET_PRINT_IMG_INFO: (state, data) => {
      console.log('data===========888888888888888888888888888', data)
      state.printImgInfo = data
      let color_ids = data.color_ids
      if (data.is_mul === 1) {
        const subObj = data.components.find(item => {
          return state.initialColor === item.color_id && state.initialSize === item.size_id
        })
        if (subObj) {
          color_ids =
            (data.component_designs[subObj.sub_basic_product_id] &&
              data.component_designs[subObj.sub_basic_product_id].color_ids) ||
            ''
        }
      }
      const colorType = color_ids.split(',').length
      const allImg = state.all_show_images_design.length
      state.showImgList = new Array(allImg / colorType)
      state.showImgListBig = new Array(allImg / colorType)
    },
    SET_SHOW_IMG_LIST: (state, data) => {
      state.showImgList.splice(data.index, 1, data.data)
    },
    SET_SHOW_IMG_LIST_BIG: (state, data) => {
      state.showImgListBig.splice(data.index, 1, data.data)
    },
    // SET_SHOW_IMG_LIST_GROUP: (state, data) => {
    //   state.showImgList = data
    // },
    SET_DESIGN_IMG_LIST: (state, data) => {
      state.designImgList = data
    },
    SET_FABRIC_LIST: (state, data) => {
      state.fabricList.splice(data.index, 1, data)
    },
    // SET_FABRIC_LIST_GRUOP: (state, data) => {
    //   state.fabricList = data
    // },
    SET_ACTIVE_DESIGN: (state, data) => {
      state.activeDesign = data
    },
    SET_RANDOM: async (state, type) => {
      if (timer !== null) {
        clearTimeout(timer)
      }
      timer = setTimeout(createImg, 300)
      async function createImg() {
        if (!type) {
          mergeImg()
          state.getWhSize = getWhCm()
        } else {
        }
      }
    },
    SET_ACTIVE_TAB: (state, data) => {
      state.activeTab = data
    },
    SET_BASIC_PRODUCT_ID: (state, data) => {
      state.basic_product_id = data
    },
    SET_ALL_SHOW_IMAGES_DESIGN: (state, data) => {
      state.all_show_images_design = data
    },
    SET_ALL_BOTTOM_IMAGES_TEMPLATE: (state, data) => {
      state.all_bottom_images_template = data
    },
    SET_PRINT_AREAS: (state, data) => {
      state.print_areas = data.map((item, index) => {
        return {
          ...item,
          index: new Date().getTime() + index
        }
      })
    },
    SET_PRICE: (state, data) => {
      state.priceData = data
    },
    SET_SINGLE_PX_ACTUAL_WIDTH: (state, data) => {
      state.singlePxToAtualWidth = data
    },
    SET_ORIGINAL_IMG_LIST: (state, data) => {
      state.originalImgList = data
    },
    SET_Wh_SIZE: (state, data) => {
      state.getWhSize = getWhCm()
    }
  },
  actions: {
    GetSingleImgInfo({ dispatch, commit }, data) {
      return new Promise(resolve => {
        getSingleImgInfo(data).then(res => {
          resetScenes()
          if (res.data.is_brand !== 1) {
            Vue.ls.set('productId', data)
          }
          // commit('SET_ACTIVE_DESIGN', 1)
          // commit('SET_BASIC_PRODUCT_ID', res.data.id)
          // commit('ClEAR_FABRIC_LIST')
          // commit('SET_SYNC_OTHER_SIDE', res.data.is_merge_design === 1)
          // commit('SET_PRINT_IMG_INFO', res.data)
          // commit('SET_ALL_BOTTOM_IMAGES_TEMPLATE', res.data.bottom_templates)
          // commit('SET_ALL_SHOW_IMAGES_DESIGN', res.data.show_images_design)
          // commit('SET_PRINT_AREAS', res.data.print_areas)
          // commit('SET_DESIGN_STYLE', res.data.design_style)
          // commit('SET_RANDOM')
          const { defaultColorId, defaultSizeId } = this.state.design
          const { colors, sizes } = res.data

          const colorsObj = colors.find(it => {
            return it.id === +defaultColorId
          })
          const sizesObj = sizes.find(it => {
            return it.id === +defaultSizeId
          })
          if (colorsObj && colorsObj.id) {
            commit('SET_INITIAL_COLOR', colorsObj.id)
          } else {
            commit('SET_INITIAL_COLOR', colors && colors.length ? colors[0].id : '')
          }

          if (sizesObj && sizesObj.id) {
            commit('SET_INITIAL_SIZE', sizesObj.id)
          } else {
            commit('SET_INITIAL_SIZE', sizes && sizes.length ? sizes[0].id : '')
          }

          // const groupInfo = {}
          // const tipLevels = {}
          // for (let i = 0; i < res.data.bottom_templates.length; i++) {
          //   groupInfo[i + 1] = {
          //     code: '',
          //     type: 0,
          //     paddingX: 0,
          //     paddingY: 0
          //   }
          //   tipLevels[i + 1] = 0
          // }

          // commit('SET_INITIAL_GROUP_INFO', groupInfo)
          // commit('SET_INIT_TIP_LEVEL', tipLevels)
          dispatch('installProduct', res)
          getPurchasePrice({
            id: res.data.id,
            data: {
              color_id: res.data.colors ? (res.data.colors.length ? res.data.colors[0].id : '') : '',
              size_id: res.data.sizes ? (res.data.sizes.length ? res.data.sizes[0].id : '') : ''
            }
          }).then(res => {
            console.log('####', res.data)
            commit('SET_PRICE', res.data)
          })
          resolve(res.data)
        })
      })
    },
    installProduct({ commit }, res) {
      const { initialColor, initialSize } = this.state.design
      resetScenes()
      commit('SET_ACTIVE_DESIGN', 1)
      commit('SET_BASIC_PRODUCT_ID', res.data.id)
      commit('ClEAR_FABRIC_LIST')
      let data = {}
      if (res.data.is_mul === 1) {
        const subObj = res.data.components.find(item => {
          return initialColor === item.color_id && initialSize === item.size_id
        })

        if (subObj) {
          data = res.data.component_designs[subObj.sub_basic_product_id] || {}
          commit('SET_SUB_COLOR', subObj.sub_color_id)
          commit('SET_SUB_SIZE', subObj.sub_size_id)
        }
      } else {
        data = res.data
        commit('SET_SUB_COLOR', '')
        commit('SET_SUB_SIZE', '')
      }
      commit('SET_SYNC_OTHER_SIDE', data.is_merge_design === 1)
      commit('SET_ALL_BOTTOM_IMAGES_TEMPLATE', data.bottom_templates)
      commit('SET_ALL_SHOW_IMAGES_DESIGN', data.show_images_design)
      console.log('print_areas=====222222888888888', data.print_areas)
      commit('SET_PRINT_AREAS', data.print_areas)
      commit('SET_DESIGN_STYLE', data.design_style)
      commit(
        'SET_PRINT_IMG_INFO',
        res.data.is_mul === 1
          ? {
              ...res.data,
              product_show_master_image: data.product_show_master_image,
              actual_sizes: data.actual_sizes,
              print_areas: data.print_areas,
              is_merge_design: data.is_merge_design,
              dpi: data.dpi,
              design_desc: data.design_desc,
              design_desc_show: data.design_desc_show
            }
          : res.data
      )
      commit('SET_RANDOM')
      const groupInfo = {}
      const tipLevels = {}
      for (let i = 0; i < res.data.bottom_templates.length; i++) {
        groupInfo[i + 1] = {
          code: '',
          type: 0,
          paddingX: 0,
          paddingY: 0
        }
        tipLevels[i + 1] = 0
      }

      commit('SET_INITIAL_GROUP_INFO', groupInfo)
      commit('SET_INIT_TIP_LEVEL', tipLevels)
    }
  }
}
export default design
